
<template>
    <div>
        <q-card flat>
            <q-card-section>
                <q-select 
                    :label='$t("FundInfo.agentlabel")' 
                    outlined
                    use-input
                    hide-selected
                    fill-input
                    input-debounce="0"
                    v-model="StoreStateTransaction.SelectedAgent"
                     
                    :options="StoreStateLookup.Agents_LK"
                    @filter ="filterFn" 
                    :rules="[ val => val !== '' && val !== null || '' + $t('common.fieldRequired') +' ']">
                    <template v-slot:no-option>
                        <q-item>
                        <q-item-section class="text-grey">
                           {{$t("common.label1")}}
                        </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'AgentSelection',
    components : {
    },
    
    data() {
        return {
            Agent : '',
            StoreStateLookup : store.state.Lookup,
            StoreStateTransaction : store.state.Transactions,
            options:[],
            StoreStateAPI : store.state.API
        }
    },computed:{
         
        agentlist : function(){
            return this.StoreStateAPI.AgentList
        }
          
    }, mounted(){
        this.$q.loading.show({spinnerSize : 50})
       this.$store.dispatch('loadAgentData')
       .then(res =>{
           if(res === -1){
               this.StoreStateTransaction.showAgent = false
                this.$q.loading.hide()
                this.$q.dialog({
                    title : 'Message',
                    message : 'Unable to retrieve Agent List' 
                })
           }else if(res === true) {
                this.$q.loading.hide()
           }else{
               this.StoreStateTransaction.showAgent = false
                this.$q.loading.hide()
                this.$q.dialog({
                    title : 'Message',
                    message : res
                })
           }
       })
    },
    methods: {
      /*  test:function(){
            console.log
            this.Agent='';
        },
        AgentDetails(){
            this.StoreStateTransaction.AgentDetails.Code = this.Agent.value;
            this.StoreStateTransaction.AgentDetails.Name = this.Agent.label;
        },*/
        filterFn:function (val, update, abort) {
           /*   if (val.length < 1) {
                abort()
                 //const needle = val.toLowerCase();
                 //this.$store.dispatch('UpdateAgentList',this.StoreStateLookup.Agents_LK.filter(v => v.value.toLowerCase().indexOf(needle) > -1))
                return
            } */
                  update(() => {
                    const needle = val.toLowerCase();
                // this.options = this.StoreStateLookup.Agents_LK.filter(v => v.toLowerCase().indexOf(needle) > -1)
                    this.StoreStateLookup.Agents_LK =this.StoreStateLookup.Agents_LK2.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
                   
                })
          
        }
        // FilterAgent (val, update) {
        //     if (val === '') {
        //         update(() => {
        //             this.Agents_LK = this.StoreStateLookup.Agents_LK
        //         })
        //         return
        //     }

        //     update(() => {
        //         const needle = val.toLowerCase()
        //         this.Agents_LK = this.StoreStateLookup.Agents_LK.filter(v => v.toLowerCase().indexOf(needle) > -1)
        //     })
        // }
    }
}
</script>